import { Colors as ChakraColors } from "@chakra-ui/react";

const Colors: ChakraColors = {
  black: "#000000",
  white: "#FFFFFF",
  blue: {
    "50": "#7587CB",
    "100": "#98DDF1",
  },
  yellow: {
    "50": "#FFF8E4",
    "100": "#BEB793",
    "700": "#FFD335",
  },
  purple: {
    "50": "#B467B6",
    "100": "#5A19EC",
    "700": "#180E30",
  },
  magenta: {
    "50": "#ff00e5",
  },
  gray: {
    "50": "#F1F2F3",
    "100": "#D8DBDF",
    "200": "#BFC4CA",
    "300": "#A6ADB5",
    "400": "#8D96A0",
    "500": "#74808B",
    "600": "#5D666F",
    "700": "#464D53",
    "800": "#2E3338",
    "900": "#171A1C",
  },
  whiteAlpha: {},
  blackAlpha: {},
  red: {
    "50": "#FF0000",
  },
  orange: {},
  green: {},
  teal: {},
  cyan: {},
  pink: {},
  linkedin: {},
  facebook: {},
  messenger: {},
  whatsapp: {},
  twitter: {},
  telegram: {},
};

export default Colors;
